export default __webpack_public_path__ + "static/media/ic_add_orange.50b49ef0.svg";